import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseServiceClient } from '../client/base-service-client';
import { InsuranceCustomerDto } from '../dto/insurance/insurance-customer.dto';
import { PolicyInstallmentDto } from '../dto/insurance/policy-installment.dto';
import { UpdateCustomerRequest } from '../dto/insurance/update-customer-request.dto';
import { PayForDuePolicyInstallmentsDto } from '../dto/payment/pay-for-due-policy-installments.dto';
import { PaymentMethodDto } from '../dto/payment/payment-method.dto';
import { PaymentSetupDto } from '../dto/payment/payment.dto';
import { TermsAndConditionsDto } from '../dto/terms-and-conditions.dto';

@Injectable({
    providedIn: 'root',
})
export class InsuranceCustomerClientService extends BaseServiceClient {
    private readonly baseUrl = `${this.ApiBaseUrl}${this.appConstants.httpClient.customersBase}`;

    getCustomer(id: string): Observable<InsuranceCustomerDto> {
        return this.get<InsuranceCustomerDto>(`${this.baseUrl}/${id}`);
    }

    searchCustomerByExternalId(realm: string, externalId?: string, phoneNumber?: string): Observable<InsuranceCustomerDto> {
        return this.get<InsuranceCustomerDto>(`${this.baseUrl}/search`, {
            params: {
                realm,
                ...(externalId ? { externalId } : {}),
                ...(phoneNumber ? { phoneNumber } : {}),
            },
        });
    }

    getCustomerPolicyInstallments(customerId: string, policyId: string): Observable<PolicyInstallmentDto[]> {
        return this.get<PolicyInstallmentDto[]>(`${this.baseUrl}/${customerId}/insurance-policies/${policyId}/installments`);
    }

    acceptTermsAndConditions(customerId: string, termsAndConditionsUuid: string): Observable<void> {
        return this.post(`${this.ApiBaseUrl}${this.appConstants.httpClient.mcaBase}/customers/${customerId}/terms-and-conditions`, {
            termsAndConditionsUuid,
        });
    }

    getTermsAndConditions(realm?: string): Observable<TermsAndConditionsDto> {
        return this.get(`${this.ApiBaseUrl}${this.appConstants.httpClient.mcaBase}/insurances/terms-and-conditions${realm ? '?realm=' + realm : ''}`);
    }
    verifyEmail(token: string): Observable<void> {
        return this.post(`${this.baseUrl}/verify-email`, { token });
    }

    resendEmailVerification(customerUuid: string): Observable<void> {
        return this.post(`${this.baseUrl}/${customerUuid}/resend-email-verification`, {});
    }

    getPaymentMethods(customerId: string): Observable<PaymentMethodDto[]> {
        return this.get<PaymentMethodDto[]>(`${this.baseUrl}/${customerId}/payment-methods`);
    }

    initializePaymentMethod(customerId: string): Observable<PaymentSetupDto> {
        return this.post<PaymentSetupDto>(`${this.baseUrl}/${customerId}/payment-methods/stripe/initialize`, {});
    }

    confirmPaymentMethod(customerId: string, setupIntentId: string): Observable<string> {
        return this.post<string>(`${this.baseUrl}/${customerId}/payment-methods/stripe/confirm`, {
            setupIntentId,
        });
    }

    payForDueInstallments(customerId: string, policyUuid: string): Observable<PayForDuePolicyInstallmentsDto> {
        return this.post<PayForDuePolicyInstallmentsDto>(`${this.baseUrl}/${customerId}/insurance-policies/${policyUuid}/installments`, {});
    }

    updateCustomer(customerId: string, customer: UpdateCustomerRequest): Observable<InsuranceCustomerDto> {
        return this.put(`${this.baseUrl}/${customerId}`, customer);
    }
}
